import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmChatopsSlackAppSelectorRoute: InvariantJiraRoute = {
	name: 'products-jsm-chatops-slack-app-selector',
	path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools/select-custom-slack-app',
	exact: true,
};
